module.exports = __webpack_public_path__ + "img/soundfield_1.5e28bb4c.jpg";